import { createIcon } from './utils';

const GroupLine = createIcon(
  'GroupIcon',
  'M3.5 21a7.2 7.2 0 1 1 14.4 0h-1.8a5.4 5.4 0 1 0-10.8 0H3.5Zm7.2-8.1a5.399 5.399 0 0 1-5.4-5.4c0-2.984 2.417-5.4 5.4-5.4 2.984 0 5.4 2.416 5.4 5.4 0 2.983-2.417 5.4-5.4 5.4Zm0-1.8c1.989 0 3.6-1.611 3.6-3.6 0-1.99-1.611-3.6-3.6-3.6a3.599 3.599 0 0 0-3.6 3.6c0 1.989 1.611 3.6 3.6 3.6Zm7.456 3.332A7.201 7.201 0 0 1 22.4 21h-1.8a5.401 5.401 0 0 0-3.183-4.926l.738-1.642Zm-.62-10.16A4.95 4.95 0 0 1 20.6 8.85a4.95 4.95 0 0 1-4.5 4.93v-1.812a3.15 3.15 0 0 0 .937-5.948l.5-1.749Z'
);

export default GroupLine;
